
import Home from '../views/Home.vue';
import Login from '../views/login.vue';
import DataIframe from '../views/dataIframe.vue';
import { getLocalAppConfig } from '../utils/appConfig';

// import ResearchWarn from '../views/research/ResearchWarn.vue';

// 获取基础路由配置
const getBaseRouters = () => {
    const appConfig = getLocalAppConfig();
        if (!appConfig) {
            return [
                {
                    path: '/',
                    redirect: (to) => {
                        // 根据应用配置中的 homePage 决定重定向目标
                        // 如果 homePage 为 "true" 或 "custom"，重定向到 /home
                        let config = getLocalAppConfig()
                        if (config && config.homePage === 'true' ) {
                            return '/home';
                        }
                        
                        // 否则重定向到 /dataIframe
                        return '/Empowerment';
                    }
                },{
                path: '/home',
                name: 'home',
                component: Home,
                meta: {
                    id: 1,
                    pageId: 1,
                    title: '首页',
                    function:'首页'
                },
            }];
        }
    const homePageConfig = appConfig.homePageConfig;
    
    const baseRouters = [
        {
            path: '/',
            redirect: (to) => {
                // 根据应用配置中的 homePage 决定重定向目标
                // 如果 homePage 为 "true" 或 "custom"，重定向到 /home
                if (appConfig.homePage === 'true' ) {
                    return '/home';
                }
                
                // 否则重定向到 /dataIframe
                return '/Empowerment';
            }
        }
    ];
    
    // 根据 homePage 配置决定是否添加 /home 路由
    if (appConfig.homePage === 'true' ) {
        baseRouters.push({
            path: '/home',
            name: 'home',
            component: Home,
            meta: {
                id: 1,
                pageId: 1,
                title: '首页',
                function:'首页'
            },
        });
    }
    
    return baseRouters;
};

export const constantRouters = [
    ...getBaseRouters(),
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: '登录',
			function:'登录'
        },
    },

  
    {
        path: '/dataIframe',
        name: 'dataIframe',
        component: DataIframe,
        meta: {
            title: '渠道-数据可视化',
			function:'数据可视化'
        },
    },

    // 移动端首页
    {
        path: '/m_index',
        name: 'm_index',
        component: () => import('../views/m_index.vue'),
        meta: {
            title: '渠道-主页',
        },
    },

    // 404页面
    {
        // 会匹配所有路径
        path: '*',
        component: () => import('../views/error.vue'),
        meta: {
            title: '页面还未开放',
			function:'页面暂无开放'
        },
    },
];
